import {Component, EventEmitter, Inject, OnInit, Output} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-upload-partner-loads-file-dialog',
  templateUrl: './upload-partner-loads-file-dialog.component.html',
  styleUrls: ['./upload-partner-loads-file-dialog.component.css']
})
export class UploadPartnerLoadsFileDialogComponent implements OnInit {

  @Inject(MAT_DIALOG_DATA) public data: any;
  @Output() upload: EventEmitter<File> = new EventEmitter<File>();
  constructor(
    public dialogRef: MatDialogRef<UploadPartnerLoadsFileDialogComponent>,
  ) { }

  ngOnInit() {

  }


  triggerOnUpload($event: any) {
    this.upload.emit($event as File);
    this.dialogRef.close();
  }
}
